import React, {Component} from 'react';
import {Modal, ModalHeader, ModalBody, ListGroupItem, ListGroupItemHeading, ListGroupItemText, ListGroup, Button} from 'reactstrap';
import axios from 'axios';
import {serverPath} from "./common";


function renderReports(reports, user, solverFunction){
    let reportsJSX = reports.map((report, index)=>{
        return renderReport(report, index, solverFunction, user && user.roleName === "professor");
    });
    return(
        <ListGroup>
            {reportsJSX}
        </ListGroup>
    );
}

function renderReport(report, index, solverFunction, isProfessor){
    return(
        <ListGroupItem>
            <ListGroupItemHeading>
                {
                    isProfessor?
                    report.reporter
                        :
                        null
                }
            </ListGroupItemHeading>
            <ListGroupItemText>
                {report.description}
            </ListGroupItemText>
            {
                isProfessor ?
                    <Button color={'success'}
                            onClick={()=>{
                                if(solverFunction !== undefined){
                                    solverFunction(report.idReport, index);
                                }
                            }}>Označi kao rešeno</Button>
                    :
                    <span/>
            }
        </ListGroupItem>
    );
}

class ViewReports extends Component{

    constructor(props){
        super(props);
        this.state={
            reports: props.reports,
            user: props.user,
            isOpen: false,
        };

        this.toggleModal = this.toggleModal.bind(this);
        this.solveReport = this.solveReport.bind(this);
    }


    toggleModal() {
        let self = this;
        this.setState({
            isOpen: !self.state.isOpen,
        });
    }

    componentWillReceiveProps(newProps){
        this.setState({
            reports: newProps.reports,
            user: newProps.user,
        })
    }
    solveReport(reportId, index){
        let self = this;
        let params = new FormData();
        params.append("action", "solveReport");
        params.append("reportId", reportId);
        axios.post(serverPath + "reportService.php", params).then((resp)=>{
                if(resp.data !== 1){
                    alert("Rešavanje nije uspelo. Pokušajte ponovo. Ukoliko se greška ponovi, obratite se administratoru.")
                }
                else{
                    self.state.reports.splice(index, 1);
                    let reports = self.state.reports;
                    self.setState({reports: reports});
                    alert("Problem uspešno uklonjen.")
                }
            }
        )
    }


    render(){
        return(
            <React.Fragment>
                {this.state.reports && this.state.reports.length > 0
                ?
                    <span className={'fa fa-exclamation-triangle active'}
                        onClick={this.toggleModal}
                        title={"Pogledajte prijavljene greške"}/>
                    :<span/>}
                <Modal isOpen={this.state.isOpen}
                        toggle={this.toggleModal}>
                    <ModalHeader toggle={this.toggleModal}> Prijavljene greške na zadatku </ModalHeader>
                    <ModalBody>
                        {renderReports(this.state.reports, this.state.user, this.solveReport)}
                    </ModalBody>
                </Modal>
            </React.Fragment>
        );

    }

}
export {ViewReports, renderReports}